'use client';
// Generated from SVG to Code Figma Plugin
import React from 'react';
import { chakra } from '@chakra-ui/react';
import { useColorMode } from '@/components/ui/color-mode';

export function Globe() {
  const { colorMode } = useColorMode();
  const iconColor = colorMode === 'light' ? '#000000' : '#FFFFFF';

  return (
    <chakra.svg
      width={'14px'}
      height={'14px'}
      viewBox="0 0 25 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <chakra.path
        d="M2.29932 13H7.77725C7.95624 16.2689 9.0074 19.3054 10.702 21.881C6.23761 21.1872 2.7501 17.5403 2.29932 13ZM2.29932 11C2.7501 6.4598 6.23761 2.81288 10.702 2.11914C9.0074 4.69468 7.95624 7.73123 7.77725 11H2.29932ZM22.2006 11H16.7226C16.5436 7.73123 15.4925 4.69468 13.7979 2.11914C18.2623 2.81288 21.7498 6.4598 22.2006 11ZM22.2006 13C21.7498 17.5403 18.2623 21.1872 13.7979 21.881C15.4925 19.3054 16.5436 16.2689 16.7226 13H22.2006ZM9.78068 13H14.7192C14.5476 15.7829 13.6646 18.3733 12.2499 20.5916C10.8352 18.3733 9.95229 15.7829 9.78068 13ZM9.78068 11C9.95229 8.21721 10.8352 5.62684 12.2499 3.40853C13.6646 5.62684 14.5476 8.21721 14.7192 11H9.78068Z"
        fill={iconColor}
      />
    </chakra.svg>
  );
}
